module.exports = __webpack_public_path__ + "c9072facfa7f68e409297c4507260ed4.svg";